import React, { Component } from 'react';
import { connect } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll/modules';
import { bindActionCreators, Dispatch } from 'redux';

import { fetchApplication, FormTypeFeedback, sendFeedback } from '../../actions';
import { DispatchWithState, StringKeyValue } from '../../actions/types';
import { AppState } from '../../reducers';
import { ApplicationReducer } from '../../reducers/application';
import { CalculatorReducer } from '../../reducers/calculator';
import { CompletionReducer } from '../../reducers/completion';
import { LoaderReducer } from '../../reducers/loader';
import ApplicationStatus from '../../util/mappings/applicationStatus';
import LoanType from '../../util/mappings/loanType';
import Control from './Control';
import LoanApproved from './LoanApproved';
import LoanCommitmentApproved from './LoanCommitmentApproved';
import Rejected from './Rejected';

interface Props {
    action: {
        fetchApplication: () => DispatchWithState;
        sendFeedback: (form: FormTypeFeedback) => DispatchWithState;
    };
    application: ApplicationReducer;
    completion: CompletionReducer;
    calculator: CalculatorReducer;
    loader: LoaderReducer;
    text: StringKeyValue;
}

class LoanApplicationReceipt extends Component<Props> {
    componentDidMount() {
        const { loader, action } = this.props;
        if (!loader.hasFetchedApplicationStatus) action.fetchApplication();
        scroll.scrollToTop();
    }

    render() {
        const { completion, action, loader, calculator, application, text } = this.props;
        const { applicationStatus } = completion.ongoing;
        const { loanType } = calculator.loanInfo;

        return (
            <div className="receipt">
                <div style={{ maxWidth: '500px', margin: '0 auto' }}>
                    <>
                        {applicationStatus === ApplicationStatus.approved && (
                            <>
                                {loanType === LoanType.loan && <LoanApproved completion={completion} text={text} />}
                                {loanType === LoanType.loanCommitment && (
                                    <LoanCommitmentApproved
                                        completion={completion}
                                        calculator={calculator}
                                        text={text}
                                    />
                                )}
                            </>
                        )}
                        {applicationStatus === ApplicationStatus.control && (
                            <Control completion={completion} action={action} loader={loader} text={text} />
                        )}
                        {applicationStatus === ApplicationStatus.rejected && (
                            <Rejected completion={completion} text={text} creditFrozen={application.creditFrozen} />
                        )}
                    </>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    application: state.application,
    completion: state.completion,
    calculator: state.calculator,
    loader: state.loader,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    action: bindActionCreators(
        {
            fetchApplication,
            sendFeedback,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanApplicationReceipt);
